module.exports = __webpack_public_path__ + "img/dick1-cover-1.11167dd3.jpg";